module.exports = __webpack_public_path__ + "static/moonamar-hladno-cijedeno-bundevino-bucino-ulje-20751017f5fbb3e23f4fec3489a91e3c.png";